import React from "react"
import "./src/styles/fancy.css"
import "./src/styles/global.scss"
import ThemeContext, { ThemeProvider } from "./src/utils/theme"
import { LanguageProvider } from "./src/utils/language"

export const wrapRootElement = ({ element }) => (
  <LanguageProvider>
    <ThemeProvider>
      <ThemeContext.Consumer>
        {({ toString }) => <div className={`theme-${toString()}`}>{element}</div>}
      </ThemeContext.Consumer>
    </ThemeProvider>
  </LanguageProvider>
)
